module.exports = __webpack_public_path__ + "static/media/rounders.a74aab5c.svg";